import React, { useState } from 'react';
import './HireArtist.css';

function HireArtist() {
  const [formData, setFormData] = useState({
    service: '',
    budget: '',
    name: '',
    phone: '',
    email: '',
    description: '',
  });
  const [status, setStatus] = useState(''); // 'sending', 'success', 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('/api/send-art-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({
          service: '',
          budget: '',
          name: '',
          phone: '',
          email: '',
          description: '',
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setStatus('error');
    }
  };

  return (
    <div className="hire-artist-page">
      <form className="hire-form" onSubmit={handleSubmit}>
        <h2>Hire an Artist</h2>

        <label htmlFor="service">Select Service</label>
        <select id="service" name="service" value={formData.service} onChange={handleChange} required>
          <option value="">-- Choose Service --</option>
          <option value="wall_mural">Wall Mural</option>
          <option value="logo">Logo</option>
          <option value="business_card">Business Card</option>
          <option value="car_paint">Car Paint</option>
          <option value="house_paint">House Paint</option>
          <option value="room_paint">Room Paint</option>
          <option value="tattoo_design">Tattoo Design</option>
        </select>

        <label htmlFor="budget">Client Budget</label>
        <select id="budget" name="budget" value={formData.budget} onChange={handleChange} required>
          <option value="">-- Select Budget --</option>
          <option value="500">$500</option>
          <option value="1000">$1,000</option>
          <option value="1500">$1,500</option>
          <option value="2000">$2,000</option>
          <option value="3500">$3,500</option>
          <option value="5000">$5,000</option>
          <option value="10000_plus">$10,000 +</option>
        </select>

        <label htmlFor="name">Full Name</label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your full name" required />

        <label htmlFor="phone">Phone Number</label>
        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" required />

        <label htmlFor="email">Email Address</label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required />

        <label htmlFor="description">Project Description</label>
        <textarea id="description" name="description" value={formData.description} onChange={handleChange} placeholder="Describe what you’d like done..." required></textarea>

        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending...' : 'Submit Request'}
        </button>

        {status === 'success' && <p style={{ color: 'green', textAlign: 'center', marginTop: '10px' }}>Request sent successfully!</p>}
        {status === 'error' && <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>Failed to send request. Please try again.</p>}
      </form>
    </div>
  );
}

export default HireArtist;